import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

export const TableRows = ({
  data,
  filterTrack,
  filterRace,
  sortDate,
  sortRaceNumber,
  sortScratchingTime,
  sortScratchedTabNo,
}) => {
  const tableData = data.data.meetingsDated
  var filteredTableData = []

  tableData
    .filter((meeting) =>
      meeting.track.name.toLowerCase().includes(filterTrack.toLowerCase())
    )
    // eslint-disable-next-line array-callback-return
    .map((meetings) => {
      filteredTableData.push(...meetings.races)
    })

  //Create new empty object.
  const DeductionData = {
    raceId: 0,
    trackName: "",
    raceName: "",
    raceNumber: 0,
    raceDate: "",
    status: "",
    runnerName: "",
    scratchedTabNo: 0,
    EmergencyReplacementNo: 0,
    scratchedTime: "",
    EmergenciesFalseMedianPrice: 0.0,
    EmergenciesFalseWinDeduction: 0.0,
    EmergenciesFalsePlaceDeduction: 0.0,
  }

  var deductionTableData = []

  //Add all of the data needed into a flat array so we can sort easily.
  // eslint-disable-next-line array-callback-return
  filteredTableData.map((race) => {
    if (race.deductionSet.length && race.status !== 'ABANDONED') {
      // eslint-disable-next-line array-callback-return
      race.deductionSet.map((deductionSet, deductionSetIndex) => {
        const deductionData = Object.create(DeductionData)
        deductionData.raceId = deductionSetIndex + dayjs().toString()
        deductionData.trackName = race.meeting.track.name
        deductionData.raceName = race.name
        deductionData.raceNumber = race.number
        deductionData.raceDate = race.startTime
        deductionData.status = deductionSet.status
        deductionData.runnerName = deductionSet.scratchedCompetitor.name
        deductionData.scratchedTabNo = deductionSet.scratchedCompetitor.tabNo
        deductionData.EmergencyReplacementNo =deductionSet.emergencyCompetitor.tabNo
        deductionData.scratchedTime = deductionSet.scratchedTime
          if (race.emergenciesFalse[deductionSetIndex].deductions[0].type === "WIN") {
              deductionData.EmergenciesFalseMedianPrice = race.emergenciesFalse[deductionSetIndex].deductions[0].scratchedMedianPrice
          }

        race.emergenciesFalse[deductionSetIndex].deductions.map(
          // eslint-disable-next-line array-callback-return
          (emergenciesFalse) => {
            if (emergenciesFalse.type === "WIN")
              deductionData.EmergenciesFalseWinDeduction = emergenciesFalse.deduction
            if (emergenciesFalse.type === "PLACE")
              deductionData.EmergenciesFalsePlaceDeduction = emergenciesFalse.deduction
          }
        )
        deductionTableData.push({ deductionData })
      })
    }
  })

  //Sort Array by deduction status.
  deductionTableData.sort(function (a, b) {
    if (a.deductionData.status < b.deductionData.status) //sort string ascending
     return -1;
    if (a.deductionData.status > b.deductionData.status)
     return 1;
    return 0; //default return value (no sorting)
  })

  dayjs.extend(utc)

  //Sort the array by date
  if (sortDate === "Ascending") {
    //Filtering by Ascending
    deductionTableData.sort(function (a, b) {
      return (
        new Date(a.deductionData.raceDate).getTime() - new Date(b.deductionData.raceDate).getTime()
      )
    })
  } else if (sortDate === "Descending") {
    //Filtering by Descending
    deductionTableData.sort(function (a, b) {
      return (
        new Date(b.deductionData.raceDate).getTime() - new Date(a.deductionData.raceDate).getTime()
      )
    })
  }

  //Sort the array by scratchingTime
  if (sortScratchingTime === "Ascending") {
    //Filtering by Ascending
    deductionTableData.sort(function (a, b) {
      return (
        new Date(a.deductionData.scratchedTime).getTime() - new Date(b.deductionData.scratchedTime).getTime()
      )
    })
  } else if (sortScratchingTime === "Descending") {
    //Filtering by Descending
    deductionTableData.sort(function (a, b) {
      return (
        new Date(b.deductionData.scratchedTime).getTime() - new Date(a.deductionData.scratchedTime).getTime()
      )
    })
  }

  // Sort the array by Scratched Tab No
  if (sortScratchedTabNo === "Ascending") {
    //Filtering by Ascending
    deductionTableData.sort(function (a, b) {
      return a.deductionData.scratchedTabNo - b.deductionData.scratchedTabNo
    })
  } else if (sortScratchedTabNo === "Descending") {
    //Filtering by Descending
    deductionTableData.sort(function (a, b) {
      return b.deductionData.scratchedTabNo - a.deductionData.scratchedTabNo
    })
  }

    //Sort the array by race number
    if (sortRaceNumber === "Ascending") {
      //Filtering by Ascending
      deductionTableData.sort(function (a, b) {
        return a.deductionData.raceNumber - b.deductionData.raceNumber
      })
    } else if (sortRaceNumber === "Descending") {
      //Filtering by Descending
      deductionTableData.sort(function (a, b) {
        return b.deductionData.raceNumber - a.deductionData.raceNumber
      })
    }



  //Output all of the data onto the table.
  return deductionTableData
    .filter((deduction) =>
      deduction.deductionData.raceNumber
        .toString()
        .toLowerCase()
        .includes(filterRace.toLowerCase())
    )
    .map((deduction, index) => {
      return (
        <tr key={index}>
          <td>{deduction.deductionData.trackName}</td>
          <td className="text-end">{deduction.deductionData.raceNumber}</td>
          <td>
            {dayjs(deduction.deductionData.raceDate)
              .local()
              .format("DD/MM/YYYY HH:mm:ss")}
          </td>
          <td>
            {dayjs(deduction.deductionData.scratchedTime)
              .local()
              .format("DD/MM/YYYY HH:mm:ss")}
          </td>
          <td>{deduction.deductionData.status}</td>
          <td>{deduction.deductionData.runnerName}</td>
          <td className="text-end">{deduction.deductionData.scratchedTabNo}</td>

          {deduction.deductionData.EmergencyReplacementNo !== 0 ? (
            <td className="text-end">
              {deduction.deductionData.EmergencyReplacementNo}
            </td>
          ) : (
            <td className="text-end">N/A</td>
          )}

          <td className="text-end">
            {deduction.deductionData.EmergenciesFalseMedianPrice.toFixed(2)}
          </td>

          <td className="text-end">
            {deduction.deductionData.EmergenciesFalseWinDeduction.toFixed(2)}
          </td>

          <td className="text-end">
            {deduction.deductionData.EmergenciesFalsePlaceDeduction.toFixed(2)}
          </td>
        </tr>
      )
    })
}
